// src/components/booking/BarberStep.jsx
import { useTenant } from "../../context/TenantContext";
import { CheckBadge, SectionHeader, StarRating, BarberStepSkeleton } from "../ui";

export default function BarberStep({ selected, onSelect }) {
  const { tenant, tenantLoading } = useTenant();
  const staff = tenant?.staff || [];

  if (tenantLoading) return <BarberStepSkeleton />;

  return (
    <div>
      <SectionHeader
        title="Pick a Team Member"
        subtitle="Choose who you'd like to work with"
      />

      {staff.length === 0 && (
        <div className="card p-8 text-center text-ink-400 text-sm font-sans max-w-2xl">
          No team members added yet. Please check back soon.
        </div>
      )}

      <div className="flex flex-col gap-4 max-w-2xl">
        {staff.map(barber => {
          const isSelected = selected?.id === barber.id;
          return (
            <div key={barber.id} onClick={() => onSelect(barber)}
              className={`card-interactive p-5 flex items-center gap-5
                ${isSelected ? "card-selected" : ""}`}>

              {/* Avatar */}
              <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${barber.color}
                              flex items-center justify-center text-white font-mono
                              font-bold text-sm shrink-0 shadow-sm`}>
                {barber.initials}
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2">
                  <h3 className={`font-semibold text-lg leading-tight
                    ${isSelected ? "text-brand-700" : "text-ink-900"}`}>
                    {barber.name}
                  </h3>
                  {isSelected && <CheckBadge />}
                </div>
                <p className="text-brand-600 text-xs font-mono mb-1">{barber.specialty}</p>
                <p className="text-ink-400 text-xs font-sans leading-relaxed hidden sm:block">
                  {barber.bio}
                </p>
                <div className="flex items-center gap-3 mt-1.5">
                  <StarRating rating={barber.rating} />
                  <span className="text-ink-400 text-xs">{barber.reviews} reviews</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <p className="text-ink-400 text-xs font-sans mt-5">
        All team members are experienced professionals.
      </p>
    </div>
  );
}
